import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { DeviceBehfaService } from 'src/app/Service/DeviceBehfa/DeviceBehfa.service';
import { GeneralService } from 'src/app/Service/General/General.service';

import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-DeviceBehfaUploadForm',
  templateUrl: './DeviceBehfaUploadForm.component.html',
  styleUrls: ['./DeviceBehfaUploadForm.component.scss']
})
export class DeviceBehfaUploadFormComponent implements OnInit {

  Procssing: boolean = false;
  FormSubmitted: boolean = false;


  constructor(
    private DeviceBehfa_Service: DeviceBehfaService,
    private Alertify_Service: AlertifyService,
    private Nav_Service: NavService,
  ) { }

  ngOnInit() {
    this.Nav_Service.CheckValidPage(51).subscribe(
      data => {
        
      }
      , error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )
  }


  ResetForm(){
    this.FormSubmitted=false
    this.Info_Upload_List=[]

    this.QRCodeInputUpload.nativeElement['value']=''
  }


  //#region Upload
  Info_Upload_List: Array<General_Interface> = []
  @ViewChild('QRCodeInputUpload') QRCodeInputUpload: ElementRef;

  QRCodeInputUpload_Enter() {
    this.Get_BehfaDevice_Info_Upload(this.QRCodeInputUpload.nativeElement['value'])
  }

  Get_BehfaDevice_Info_Upload(QRCodeInput: string) {

    if (!this.Procssing) {
      this.Procssing = true
      this.DeviceBehfa_Service.GetInfobyQR(QRCodeInput).subscribe(
        data => {

          this.Procssing = false
          this.QRCodeInputUpload_Esc()

          if (data.id == -1) {
            this.Alertify_Service.ErrorMessage("QR Code اسکن شده معتبر نمی باشد")
          }
          else if (this.Info_Upload_Exist(data)) {
            this.Alertify_Service.ErrorMessage("QR Code اسکن شده در لیست موجود است")
          }
          else {
            data.dsc=QRCodeInput
            this.Info_Upload_List.push(data)
            this.Alertify_Service.SuccessMessage("اطلاعات تجهیز خوانده شد")
          }

        }, error => {
          this.Procssing = false
          this.Alertify_Service.ErrorMessage("QR Code اسکن شده معتبر نمی باشد")

        }
      )
    }

  }

  QRCodeInputUpload_Esc() {
    this.QRCodeInputUpload.nativeElement['value'] = ''
  }

  Info_Upload_Exist(input: General_Interface) {
    for (let item of this.Info_Upload_List) {
      if (item.code == input.code) {
        return true
      }
    }
    return false
  }

  Info_Upload_Remove(id: number) {
    this.Info_Upload_List.splice(id, 1)
    this.Alertify_Service.SuccessMessage("حذف شد")
    this.QRCodeInputUpload.nativeElement.focus();
  }

  
  QRCodeChangeUpload() {
    this.Procssing = true

    var Code: Array<string> = []
    for (let item of this.Info_Upload_List) {
      Code.push(item.dsc)
    }

    this.DeviceBehfa_Service.PostUpload(Code).subscribe(
      data => {

        this.Procssing = false
        this.QRCodeInputUpload_Esc()
        this.Info_Upload_List = data

        this.FormSubmitted=true
        this.Alertify_Service.SuccessMessage("تجهیزات برای خروج بررسی شد")

      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }


  //#endregion

}

